import type { Revision, RevisionType } from '../types';
import { randomUUID } from '../utils';

/**
 * When doing a fast-forward merge/update, we still want to create a new revision.
 */
export function createFastForwardRevision(
    input: Revision,
    ancestor: Revision,
    type: RevisionType.Merge | RevisionType.Update
): Revision {
    return {
        id: randomUUID(),
        type,
        contentId: input.contentId,
        parents: [ancestor.id, input.id],
        pages: input.pages,
        files: input.files,
        rootPages: input.rootPages,
        edits: input.edits,
        variables: input.variables,
        reusableContents: input.reusableContents,
        tags: input.tags,
    };
}
